var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(this.$route.meta.topShow)?_c('HomeHeader'):_vm._e(),_c('router-view'),(this.$route.meta.bottomShow)?_c('HomeFooter'):_vm._e(),(this.$route.meta.wxbar)?_c('FloatBar'):_vm._e(),(_vm.cookieVisible)?_c('CookieView'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }